import React, { useState, useEffect } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import SupplierList from "./dash-components/SupplierList";
import LeaderBoard from "./LeaderBoard/LeaderBoard";
import { useCompany } from "../../../contexts/CompanyContext";
import Banner from "../../global/Banner";

/**
 * Renders a supplier selection page with leaderboard and optional banner.
 */
export default function SelectDash() {
  const [loading, setLoading] = useState(true);
  const { suppliers } = useCompany();

  useEffect(() => {
    if (suppliers && suppliers.length > 0) {
      setTimeout(() => setLoading(false), 500); // reduced to avoid long wait
    } else {
      setLoading(false); // avoid infinite spinner if suppliers is empty
    }
  }, [suppliers]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 550,
          userSelect: "none",
          mb: 3,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        Choose a dashboard
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" my={4}>
          <CircularProgress />
        </Box>
      ) : (
        <SupplierList url="/Supplier/" />
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          my: { xs: 2, sm: 4 },
        }}
      >
        <Banner imgUrl="https://images.squarespace-cdn.com/content/v1/602d1a7212b33a4973f1ba6a/cd243ba0-b0bb-469d-adef-753e186c6281/Web+Banner+-+655x165px+%281200+x+300+px%29+%281%29.png" />
      </Box>

      <LeaderBoard />
    </Box>
  );
}
